import type { Inspection } from '../types';

/**
 * 点検のお問い合わせ - モックデータ
 * 本番環境ではAPIから取得する
 */
export const allInspections: Inspection[] = [
  {
    id: 1,
    status: 'received',
    requestDate: '2025/08/01 10:00',
    visitDate: '日程調整中',
    inspectionItems: [
      { category: '定期点検', location: '外壁' },
      { category: '定期点検', location: '屋根' },
    ],
    contractor: 'Jun Corporation',
    receptionManager: '受付 太郎',
  },
  {
    id: 2,
    status: 'visit_confirmed',
    requestDate: '2025/08/02 11:00',
    visitDate: '2025/08/10 13:00',
    inspectionItems: [
      { category: '設備点検', location: '給湯器' },
    ],
    contractor: 'Jun Corporation',
    receptionManager: '受付 太郎',
    manager: '点検 員一',
  },
  {
    id: 3,
    status: 'in_progress',
    requestDate: '2025/08/03 12:00',
    visitDate: '2025/08/12 10:00',
    inspectionItems: [
      { category: '設備点検', location: 'エアコン' },
      { category: '設備点検', location: '換気扇' },
    ],
    contractor: 'Jun Corporation',
    receptionManager: '受付 太郎',
    manager: '点検 員二',
  },
  {
    id: 4,
    status: 'result_confirmation',
    requestDate: '2025/08/04 13:00',
    visitDate: '2025/08/15 14:00',
    inspectionItems: [
      { category: '定期点検', location: '基礎' },
    ],
    contractor: 'Jun Corporation',
    receptionManager: '受付 太郎',
    manager: '点検 員三',
    inspectionResult: '異常なし',
    // モックデータではPDF URLを設定しない（本番ではAPIから取得）
    // 未設定時は「準備中」UIが表示される
    resultReportUrl: undefined,
  },
  {
    id: 5,
    status: 'completed',
    requestDate: '2025/08/05 14:00',
    visitDate: '2025/08/20 09:00',
    inspectionItems: [
      { category: '定期点検', location: '外壁' },
      { category: '定期点検', location: '屋根' },
      { category: '設備点検', location: '給湯器' },
    ],
    contractor: 'Jun Corporation',
    receptionManager: '受付 太郎',
    manager: '点検 員一',
    inspectionResult: '軽微な劣化あり（経過観察）',
    // モックデータではPDF URLを設定しない（本番ではAPIから取得）
    resultReportUrl: undefined,
  },
];
